import _Object$create from "core-js/library/fn/object/create.js";
import setPrototypeOf from "./setPrototypeOf.js";
function _inheritsLoose(t, o) {
  t.prototype = _Object$create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
export { _inheritsLoose as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/esm/inheritsLoose.js
// module id = 6
// module chunks = 2